import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button, Image } from "react-bootstrap";
import Header from "../../header/Header";
import Footer from "../../footer/Footer";
import Loader from "../../loader/Loader";
import Mission1 from "../../../assets/images/index/Mission1.jpg";
import Mission2 from "../../../assets/images/index/Mission2.jpg";
import screenie1 from "../../../assets/images/index/screenshots/screenie-1.jpg";
import screenie2 from "../../../assets/images/index/screenshots/screenie-2.jpg";
import screenie3 from "../../../assets/images/index/screenshots/screenie-3.jpg";
import grandMotherAndGrandson from "../../../assets/images/index/grandmother-and-grandson.jpg";
import quoteZoneLogo from "../../../assets/images/third-party-logos/quote-zone-logo.png";
import giftCard1 from "../../../assets/images/gift-cards/life-style-gift-card.jpg";
import giftCard2 from "../../../assets/images/gift-cards/john-lewis-gift-card.jpg";
import giftCard3 from "../../../assets/images/gift-cards/river-island-gift-card.jpg";
import giftCard4 from "../../../assets/images/gift-cards/one4all-gift-card.jpg";
import giftCard5 from "../../../assets/images/gift-cards/boots-gift-card.jpg";
import giftCard6 from "../../../assets/images/gift-cards/m-and-s-gift-card.jpg";
import UspSection from "../../templates/UspSection";
import PricingPlanCallToAction from "../../templates/PricingPlanCallToAction";
import PageCallToAction from "../PageCallToAction";
import TestimonialsSlider from "../../testimonialsSlider/TestimonialsSlider";

const HowItWorks = () => {
  const [loading, setloading] = useState(true);
  useEffect(() => {
    setTimeout(() => {
      setloading(false);
    }, 500);
  }, []);

  return (
    <>
      <Header />
      {loading ? (
        <Loader />
      ) : (
        <>
          <div className="hero">
            <Container>
              <Row className="justify-content-between gy-12 gy-md-13 gx-xxl-0">
                <Col xl="13" xxl="13" xxxl="13">
                  <h1 className="h2 mb-5 mb-md-6">
                    Our Mission At Elderly Life
                  </h1>
                  <div className="d-block d-xl-none mb-5">
                    <Image
                      src={Mission1}
                      className="img-fluid rounded-4"
                      alt=""
                    />
                  </div>
                  <p className="lead mb-5 text-dark">
                    Elderly Life began with something deeply personal: watching our own families struggle to stay on top of everyday life as they got older.
                  </p>
                  <p className="lead mb-5 text-dark">
                    We saw parents forget renewals, lose track of paperwork, struggle with subscriptions, and feel overwhelmed by modern life moving too fast around them.
                  </p>
                  <p className="lead mb-5 text-dark">
                    And we saw the pressure quietly fall on the people who love them most. Sons, daughters, partners, friends and carers trying to help manage everything alone.
                  </p>
                  <p className="lead mb-3 text-dark">
                    That experience led to one simple belief:
                  </p>
                  <p className="lead mb-5 text-dark fw-bold">
                    Growing older shouldn’t mean losing independence.
                  </p>
                  <p className="lead mb-5 text-dark">
                    Elderly Life was created to help people stay organised, supported and connected, while giving trusted family members peace of mind in the background.
                  </p>
                  <p className="lead mb-3 text-dark">
                    Because sometimes, the smallest things create the biggest stress:
                  </p>
                  <ul className="mb-6 text-dark lead">
                    <li>missed renewals</li>
                    <li>forgotten reminders</li>
                    <li>scattered paperwork</li>
                    <li>unused subscriptions</li>
                    <li>important details no one can find when needed</li>
                  </ul>
                  <p className="lead mb-5 text-dark">
                    We believe technology should feel human, calm and supportive, not confusing, overwhelming or cold.
                  </p>
                  <p className="lead mb-5 text-dark">
                    And most importantly:
                  </p>
                  <p className="lead fw-bold text-dark mb-0">
                    we believe nobody should have to manage life’s essentials alone.
                  </p>
                </Col>
                <Col xl="10" xxl="9" className="offset-xl-1 d-none d-xl-block">
                  <div style={{ position: "sticky", top: "2rem" }}>
                    <Image
                      src={Mission1}
                      className="img-fluid rounded-4"
                      style={{ maxHeight: "480px", width: "100%", objectFit: "cover" }}
                      alt=""
                    />
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
          <Container>
            <section className="py-10 py-md-11 py-xl-12 py-xxxl-13 border-top mt-10">
              <Row className="justify-content-between gy-10 gx-xxl-0 align-items-stretch">
                <Col xl="13" xxl="13" xxxl="13">
                  <h2 className="mb-5 mb-md-6">
                    Built Around Real Everyday Support
                  </h2>
                  <div className="d-block d-xl-none mb-5">
                    <Image
                      src={Mission2}
                      className="img-fluid rounded-4"
                      alt=""
                    />
                  </div>
                  <p className="lead mb-5 text-dark">
                    Elderly Life was created to help older adults stay organised, independent and supported in everyday life, while making it easier for trusted family members to help when needed.
                  </p>
                  <p className="lead mb-3 text-dark">
                    Because real support is often the small things:
                  </p>
                  <ul className="mb-5 text-dark lead">
                    <li>remembering important dates</li>
                    <li>keeping track of household essentials</li>
                    <li>staying on top of renewals</li>
                    <li>sharing responsibilities with people you trust</li>
                    <li>feeling less overwhelmed by modern life</li>
                  </ul>

                  <p className="lead mb-5 text-dark">
                    We believe growing older should still feel independent, connected and dignified.
                  </p>
                  <p className="lead mb-5 text-dark">
                    And we believe technology should feel calm, simple and human, never confusing or overwhelming.
                  </p>

                  <p className="lead mb-3 fw-bold text-dark">
                    At Elderly Life, we believe in:
                  </p>
                  <ul className="list-unstyled lead text-dark mb-6">
                    <li className="mb-2 d-flex align-items-start">
                      <span className="text-success me-3 fw-bold">✓</span>
                      <span>Independence with support</span>
                    </li>
                    <li className="mb-2 d-flex align-items-start">
                      <span className="text-success me-3 fw-bold">✓</span>
                      <span>Organisation without stress</span>
                    </li>
                    <li className="mb-2 d-flex align-items-start">
                      <span className="text-success me-3 fw-bold">✓</span>
                      <span>Privacy with control</span>
                    </li>
                    <li className="mb-2 d-flex align-items-start">
                      <span className="text-success me-3 fw-bold">✓</span>
                      <span>Family support made simpler</span>
                    </li>
                    <li className="mb-0 d-flex align-items-start">
                      <span className="text-success me-3 fw-bold">✓</span>
                      <span>Technology designed with compassion</span>
                    </li>
                  </ul>

                  <p className="lead fw-bold text-dark mt-5 mb-0">
                    Because nobody should have to manage life’s essentials alone.
                  </p>
                </Col>
                <Col xl="10" xxl="9" className="offset-xl-1 d-none d-xl-block">
                  <div style={{ position: "sticky", top: "2rem" }}>
                    <Image
                      src={Mission2}
                      className="img-fluid rounded-4"
                      style={{ maxHeight: "480px", width: "100%", objectFit: "cover" }}
                      alt=""
                    />
                  </div>
                </Col>
              </Row>
            </section>
            <section className="pb-11 pb-md-12 pb-xl-13 pb-xxxl-14">
                <Row className="row-cols-1 row-cols-md-2 row-cols-xl-4 justify-content-center gy-5 gy-md-7 gy-xl-0 gx-xxxl-6">
                  <Col>
                    <div className="bg-primary-light rounded-3 p-6 p-xxxl-7 h-100">
                      <Row className="justify-content-center mb-7">
                        <Col xs="16" xl="19" xxxl="18">
                          <h4 className="h6 text-center mb-0">
                            Keeping tabs on all your expenses
                          </h4>
                        </Col>
                      </Row>
                      <Image
                        src={screenie1}
                        className="img-fluid rounded-3 shadow"
                        alt=""
                      />
                    </div>
                  </Col>
                  <Col>
                    <div className="bg-primary-light rounded-3 p-6 p-xxxl-7 h-100">
                      <Row className="justify-content-center mb-7">
                        <Col xs="18" xl="21" xxxl="18">
                          <h4 className="h6 text-center mb-0">
                            Comparing best prices through the comparison portal
                          </h4>
                        </Col>
                      </Row>
                      <Image
                        src={screenie2}
                        className="img-fluid rounded-3 shadow mb-3"
                        alt=""
                      />
                      <div className="d-flex justify-content-center align-items-center">
                        <div className="small-xs fw-semibold text-center">
                          Powered by
                        </div>
                        <Image
                          src={quoteZoneLogo}
                          height="16"
                          className="ms-2"
                          alt=""
                        />
                      </div>
                    </div>
                  </Col>
                  <Col>
                    <div className="bg-primary-light rounded-3 p-6 p-xxxl-7 h-100">
                      <Row className="justify-content-center mb-7">
                        <Col xs="18" xl xxxl="19">
                          <h4 className="h6 text-center mb-0">
                            Hacks to trim down bills and grab affordable
                            essentials
                          </h4>
                        </Col>
                      </Row>
                      <div className="me-9 mb-5">
                        <Image
                          src={screenie3}
                          className="img-fluid rounded-3 shadow"
                          alt=""
                        />
                      </div>
                      <div className="ms-9 mt-4">
                        <Image
                          src={grandMotherAndGrandson}
                          className="img-fluid rounded-3 shadow"
                          alt=""
                        />
                      </div>
                    </div>
                  </Col>
                  <Col>
                    <div className="bg-primary-light rounded-3 p-6 p-xxxl-7 h-100">
                      <Row className="justify-content-center mb-7">
                        <Col xs="18" xl xxxl="19">
                          <h4 className="h6 text-center mb-0">
                            Utilise your vouchers and coupons
                          </h4>
                        </Col>
                      </Row>
                      <Row className="justify-content-center gy-5 gx-xxxl-6 gy-xxxl-6">
                        <Col xs="auto">
                          <Image
                            src={giftCard1}
                            className="img-gift-card shadow rounded-1"
                            alt=""
                          />
                        </Col>
                        <Col xs="auto">
                          <Image
                            src={giftCard2}
                            className="img-gift-card shadow rounded-1"
                            alt=""
                          />
                        </Col>
                        <Col xs="auto">
                          <Image
                            src={giftCard3}
                            className="img-gift-card shadow rounded-1"
                            alt=""
                          />
                        </Col>
                        <Col xs="auto">
                          <Image
                            src={giftCard4}
                            className="img-gift-card shadow rounded-1"
                            alt=""
                          />
                        </Col>
                        <Col xs="auto">
                          <Image
                            src={giftCard5}
                            className="img-gift-card shadow rounded-1"
                            alt=""
                          />
                        </Col>
                        <Col xs="auto">
                          <Image
                            src={giftCard6}
                            className="img-gift-card shadow rounded-1"
                          />
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>
              </section>
            <section className="py-6">
              <PageCallToAction messageContent="Start today, for yourself or someone you care about." />
            </section>
            <UspSection />
          </Container>
          {/* <TestimonialsSlider /> */}
          <PricingPlanCallToAction />
          <Footer />
        </>
      )}
    </>
  );
};

export default HowItWorks;
